export const SET_ALL = 'workshops/SET_ALL';
export const SET_BY_ID = 'workshops/SET_BY_ID';
